import { APP_KIND } from "@config";

export default function V2Brand({ appKind = APP_KIND }) {
  const productName = appKind === "trainer" ? "TRAINER" : "MONITORING";

  return (
    <div className="relative z-[5] flex w-max flex-col items-start gap-[7px] text-white">
      <img
        className="h-[124px] w-[124px] self-center object-contain [filter:drop-shadow(0_0_9px_rgba(52,203,255,0.24))]"
        src="/icon.png"
        alt=""
        aria-hidden="true"
      />
      <span className="v2-display text-[21px] font-bold uppercase leading-none tracking-[0.01em] text-[#f7f7ff]">
        PREDITWINS <strong className="font-bold text-v2-cyan">{productName}</strong>
      </span>
    </div>
  );
}
